export default "__VITE_ASSET__b918892b__"